import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { TableColumn } from "./TableColumn";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { Buttons } from './Buttons';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'custom-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class TableComponent implements OnInit, AfterViewInit, OnChanges {

  public tableDataSource = new MatTableDataSource([]);
  public tableDataSource2 = new MatTableDataSource([]);
  public tableDataSource3 = new MatTableDataSource([]);
  public tableDataSource4 = new MatTableDataSource([]);

  public displayedColumns: string[];
  public displayedColumns2: string[];
  public displayedColumns3: string[];
  public displayedColumns4: string[];
  public actionColumnNames: string[];

  @ViewChild(MatPaginator, { static: false }) matPaginator: MatPaginator;
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  checkedactive: boolean = false;
  selectallcheckedactive: boolean = true;
  masterSelected: boolean;
  expandedElement: null;
  expandExpandedElement: null;
  expandExpandedElement3: null;
  expand: boolean = false;
  isExpand3: boolean = false;
  isShowActiveStatus: boolean = true;
  innerToggledElement: any | null = null;

  isExtraTextField: boolean = false;
  @Input() isRemoveChargeback: boolean = true;

  data1: any[];
  data2: any[];
  data3: any[];
  data4: any[];

  @Input() isCheckboxActive = false;
  @Input() isDateActive = false;
  @Input() isRefreshActive = false;
  @Input() isChecked = false;
  @Input() checkActive = false;
  @Input() isPageable = true;
  @Input() isSortable = false;
  @Input() isExpand = false;
  @Input() isAction5 = false;
  @Input() isAction4 = false;
  @Input() isAction3 = false;
  @Input() isAction2 = false;
  @Input() isAction1 = true;
  @Input() isExportExcel = true;
  @Input() centerSearchFilter = false;
  @Input() topLevelButtons1: string;
  @Input() topLevelButtons2: string;
  @Input() topLevelButtons3: string;
  @Input() action1Column: string;
  @Input() action2Column: string;
  @Input() action3Column: string;
  @Input() action4Column: string;
  @Input() isFilterable = true;
  @Input() tableColumns: TableColumn[];
  @Input() tableColumns2: TableColumn[];
  @Input() tableColumns3: TableColumn[];
  @Input() tableColumns4: TableColumn[];
  @Input() actions: TableColumn[];
  @Input() actionsextracol: TableColumn[];
  @Input() checkboxes: TableColumn[];
  @Input() checkboxExp4: TableColumn[];
  @Input() actionButtons: TableColumn[];
  @Input() buttons: Buttons[];
  @Input() rowActionIcon: string;
  @Input() checkbox: string;
  @Input() headder: string;
  @Input() headerSelectLabel = 'Show';
  @Input() headerSelectOptions: { value: string; label: string }[] = null;
  @Input() headerSelectValue: string;
  @Input() headerSelectDisabled = false;
  @Input() headerSelectLoading = false;
  @Input() paginationSizes: number[] = [5, 10, 15];
  @Input() defaultPageSize = this.paginationSizes[1];
  @Input() hide = true;

  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @Output() rowAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateAction: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() removeChargebackAction: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() openPopupAction: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() redirectUrl: EventEmitter<any> = new EventEmitter<any>();
  @Output() excelExport: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionsOnRow: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() innerActionsOnRow: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() innerActionsOnRow3: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() innerActionsOnRow4: EventEmitter<any> = new EventEmitter<{ row: any, value: any }>();
  @Output() actionOnButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewEditAction: EventEmitter<any> = new EventEmitter<{ row: any, value: any, name: string }>();
  @Output() checkboxShowHide: EventEmitter<any> = new EventEmitter<{ value: any }>();
  @Output() dateShowHide: EventEmitter<any> = new EventEmitter<{ value: any }>();
  @Output() refreshShowHide: EventEmitter<any> = new EventEmitter<{ value: any }>();
  @Output() checkboxExpFour: EventEmitter<any> = new EventEmitter<{ value: any }>();
  @Output() selectAllAction: EventEmitter<any> = new EventEmitter<{ value: any }>();
  @Output() headerSelectChange = new EventEmitter<string>();
  @Output() commissionReportClick: EventEmitter<any> = new EventEmitter<{ trackingId: string, element: any }>();

  // this property needs to have a setter, to dynamically get changes from parent component
  @Input() set tableData(data: any[]) {
    this.data1 = data;
    this.setTableDataSource(data);
  }

  @Input() set tableData2(data: any[]) {
    this.data2 = data;
    this.setTableDataSource2(data);
  }

  @Input() set tableData3(data: any[]) {
    this.data3 = data;
    this.setTableDataSource3(data);
  }

  @Input() set tableData4(data: any[]) {
    this.data4 = data;
    this.setTableDataSource4(data);
  }

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      this.isExtraTextField = true;
      this.isRemoveChargeback = false;
    } else {
      this.isExtraTextField = false;
    }
  }

  // we need this, in order to make pagination work with *ngIf
  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.matPaginator;
  }
  ngOnChanges(changes: SimpleChanges) {

    const columnNames = this.tableColumns.map((tableColumn: TableColumn) => tableColumn.name);
    //console.log("columnNames : ", changes);
    if (this.checkbox) {
      this.displayedColumns = [this.checkbox, ...columnNames]
    } else {
      this.displayedColumns = columnNames;
    }

    if (this.tableColumns2?.length && this.data2?.length) {
      //console.log(this.tableData2);
      const columnNames2 = this.tableColumns2.map((tableColumn2: TableColumn) => tableColumn2.name);
      //console.log('columnNames2 ===', columnNames2);
      this.displayedColumns2 = columnNames2;
    }
    else {
      this.tableData2 = [];
      this.displayedColumns2 = [];
      this.setTableDataSource2(this.tableData2);
    }
    if (this.tableColumns3?.length && this.data3?.length) {
      if (this.checkboxes?.length > 0) {
        const actionColumnNames = this.checkboxes.map((checkbox: TableColumn) => checkbox.name);
        this.displayedColumns3 = actionColumnNames;
        const columnNames3 = this.tableColumns3.map((tableColumn3: TableColumn) => tableColumn3.name);

        for (let columnName of columnNames3) {
          this.displayedColumns3.push(columnName);
        }
      }
      else {
        const columnNames3 = this.tableColumns3.map((tableColumn3: TableColumn) => tableColumn3.name);
        this.displayedColumns3 = columnNames3;
      }
    }
    else {
      this.tableData3 = [];
      this.displayedColumns3 = [];
      this.setTableDataSource3(this.tableData3);
    }
    if (this.tableColumns4?.length && this.data4?.length) {
      //console.log("this.data4 = "+this.data4);
      if (this.checkboxExp4?.length > 0) {
        const actionColumnNames = this.checkboxExp4.map((checkbox: TableColumn) => checkbox.name);
        this.displayedColumns4 = actionColumnNames;
        const columnNames4 = this.tableColumns4.map((tableColumn4: TableColumn) => tableColumn4.name);

        for (let columnName of columnNames4) {
          this.displayedColumns4.push(columnName);
        }
      }
      else {
        const columnNames4 = this.tableColumns4.map((tableColumn4: TableColumn) => tableColumn4.name);
        this.displayedColumns4 = columnNames4;
      }
    }
    else {
      // console.log("this.data4 = "+this.data4);
      this.tableData4 = [];
      this.displayedColumns4 = [];
      this.setTableDataSource4(this.tableData4);
    }

    if (this.actionsextracol?.length > 0) {
      const actionColumnNames = this.actionsextracol.map((action: TableColumn) => action.name);
      console.log(actionColumnNames);
      for (let actionColumn of actionColumnNames) {
        console.log('=========================');
        console.log(actionColumn);
        console.log(this.action2Column);


        if (actionColumn === this.topLevelButtons1 || actionColumn === this.topLevelButtons2 || actionColumn === this.topLevelButtons3) {
          console.log("===0");
          this.displayedColumns.push(actionColumn);
        }

        if (actionColumn === this.action2Column) {
          console.log("===1");
          this.isAction1 = false;
          this.displayedColumns.push(actionColumn);
        }



      }
    }

    if (this.actions?.length > 0) {
      const actionColumnNames = this.actions.map((action: TableColumn) => action.name);
     // console.log(actionColumnNames);
      for (let actionColumn of actionColumnNames) {
       // console.log('=========================');
       // console.log(actionColumn);
       // console.log(this.action1Column);


        if (actionColumn === this.topLevelButtons1 || actionColumn === this.topLevelButtons2 || actionColumn === this.topLevelButtons3) {
         // console.log("===0");
          this.displayedColumns.push(actionColumn);
        }

        if (actionColumn === this.action1Column) {
         // console.log("===1");
          this.isAction1 = false;
          this.displayedColumns.push(actionColumn);
        }

        if (this.isAction1) {
          //console.log("===2");
          this.displayedColumns.push(actionColumn);
        }

        if (this.tableColumns2?.length && this.isAction2 && !this.action2Column) {
         // console.log("===3");
          this.displayedColumns2.push(actionColumn);
        }

        if (this.tableColumns3?.length && this.isAction3 && !this.action3Column) {
         // console.log("===4");
          this.displayedColumns3.push(actionColumn);
        }

        if (this.tableColumns2?.length && actionColumn === this.action2Column) {
          //console.log("===5");
          this.displayedColumns2.push(actionColumn);
          this.isAction2 = true;
        }

        if (this.tableColumns3?.length && actionColumn === this.action3Column) {
          //console.log("===6");
          this.displayedColumns3.push(actionColumn);
          this.isAction3 = true;
        }

        if (actionColumn === this.action4Column) {
        //  console.log("===7");
          this.displayedColumns4.push(actionColumn);
        }

      }
    }




  }


  setTableDataSource(data: any) {
    this.tableDataSource = new MatTableDataSource<any>(data);
    this.tableDataSource.paginator = this.matPaginator;
    this.tableDataSource.sort = this.matSort;


  }

  setTableDataSource2(data: any) {
    // console.log(data);
    this.tableDataSource2 = new MatTableDataSource<any>(data);
    //this.tableDataSource2.paginator = this.matPaginator;
    this.tableDataSource2.sort = this.matSort;
    // console.log('tableDataSource2', this.tableDataSource2);
  }

  setTableDataSource3(data: any) {
    this.tableDataSource3 = new MatTableDataSource<any>(data);
    // this.tableDataSource3.paginator = this.matPaginator;
    this.tableDataSource3.sort = this.matSort;


    //console.log('tableDataSource3', this.tableDataSource3);
  }

  setTableDataSource4(data: any) {
    this.tableDataSource4 = new MatTableDataSource<any>(data);
    //this.tableDataSource4.paginator = this.matPaginator;
    this.tableDataSource4.sort = this.matSort;
    //console.log('tableDataSource4', this.tableDataSource4);
  }

  applyFilter(value: string) {
    this.tableDataSource.filter = value.trim().toLocaleLowerCase();
  }

  sortTable(sortParameters: Sort) {
    console.log("sortTable() called");
    console.log(sortParameters);
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns.find(column => column.name === sortParameters.active).dataKey;
    const keyName = sortParameters.active;

    if (sortParameters.direction === 'asc') {
      console.log("Inside IF");
      this.data1 = this.data1.sort((a: any, b: any) => a[keyName].toString().localeCompare(b[keyName].toString()));
      this.data1 = this.data1.sort((a: any, b: any) => a[keyName] - b[keyName]);
      this.setTableDataSource(this.data1);
    } else if (sortParameters.direction === 'desc') {
      console.log("Inside ELSE IF");
      this.data1 = this.data1.sort((a: any, b: any) => b[keyName].toString().localeCompare(a[keyName].toString()));
      this.data1 = this.data1.sort((a: any, b: any) => b[keyName] - a[keyName]);
      this.setTableDataSource(this.data1);
    }
    //this.sort.emit(sortParameters);

  }

  sortTable2(sortParameters: Sort) {
    console.log("sortTable2() called");
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns2.find(column => column.name === sortParameters.active).dataKey;
    const keyName = sortParameters.active;
    //console.log(this.data2);
    if (sortParameters.direction === 'asc') {
      this.data2 = this.data2.sort((a: any, b: any) => a[keyName].toString().localeCompare(b[keyName].toString()));
      this.data2 = this.data2.sort((a: any, b: any) => a[keyName] - b[keyName]);
      this.setTableDataSource2(this.data2);
    } else if (sortParameters.direction === 'desc') {
      this.data2 = this.data2.sort((a: any, b: any) => b[keyName].toString().localeCompare(a[keyName].toString()));
      this.data2 = this.data2.sort((a: any, b: any) => b[keyName] - a[keyName]);
      this.setTableDataSource2(this.data2);
    }
    //this.sort.emit(sortParameters);
  }

  sortTable3(sortParameters: Sort) {
    console.log("sortTable3() called");
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns3.find(column => column.name === sortParameters.active).dataKey;
    const keyName = sortParameters.active;
    //console.log(this.data3);
    if (sortParameters.direction === 'asc') {
      this.data3 = this.data3.sort((a: any, b: any) => a[keyName].toString().localeCompare(b[keyName].toString()));
      this.data3 = this.data3.sort((a: any, b: any) => a[keyName] - b[keyName]);
      this.setTableDataSource3(this.data3);
    } else if (sortParameters.direction === 'desc') {
      this.data3 = this.data3.sort((a: any, b: any) => b[keyName].toString().localeCompare(a[keyName].toString()));
      this.data3 = this.data3.sort((a: any, b: any) => b[keyName] - a[keyName]);
      this.setTableDataSource3(this.data3);
    }
    //this.sort.emit(sortParameters);
  }

  emitRowAction(row: any) {
    this.rowAction.emit(row);
  }

  removeChargeback1(row: any, value: any) {
    console.log("removeChargeback() called");
    this.removeChargebackAction.emit({ row, value });
  }

  selctedColumn(row: any, value: any) {
    // console.log(value.currentTarget.checked);
    // if (value.currentTarget.checked) {
    //   this.selectallcheckedactive = true;
    //   console.log("Inside IF");
    // } else {
    //   console.log("Inside ELSE");
    //   this.selectallcheckedactive = false;
    // }
    this.updateAction.emit({ row, value });
  }

  selectAll(value: any) {
    //console.log(value.currentTarget.checked);
    if (value.currentTarget.checked)
      this.checkedactive = true;
    else
      this.checkedactive = false;
    this.selectAllAction.emit({ value });
  }

  viewEditAccess(row: any, value: any, name: string) {
    //console.log("name=" + name);
    this.viewEditAction.emit({ row, value, name });
  }

  changed(value: any) {
    //console.log('changed val =  ', value.target.checked);
    this.checkboxShowHide.emit({ value });
  }
  changedDate(value: any) {
    //console.log('changedDate val =  ', value.target.checked);
    this.dateShowHide.emit({ value });
  }
  refreshPage() {
    this.refreshShowHide.emit({});
  }
  fieldsChange(value: any) {
    //console.log(' val =  ', value.target.checked);
    this.checkboxExpFour.emit({ value });
  }

  actionOnRow(row: any, value: any) {
    console.log("Inside actionOnRow");
    // console.log(row, ' val   ', value);
    this.actionsOnRow.emit({ row, value });
    if (value === 'View')
      this.toggleRow(row);
  }

  openPopup(row: any, value: any) {
    console.log("Inside openPopup");
    this.openPopupAction.emit({ row, value });
  }

  innerActionOnRow(row: any, value: any) {
    //console.log(row, 'val   ', value);
    this.innerActionsOnRow.emit({ row, value });
    if (value === 'View')
      this.innerToggleRow(row);

  }

  innerActionOnRow3(row: any, value: any) {
    // console.log(row, 'val   ', value);
    this.innerActionsOnRow3.emit({ row, value });
    if (value === 'View')
      this.innerToggleRow3(row);
  }
  innerActionOnRow4(row: any, value: any) {
    //console.log(row, 'val   ', value);
    this.innerActionsOnRow4.emit({ row, value });
    // if (value === 'View')
    //   this.innerToggleRow3(row);
  }

  exportExcel() {
    this.excelExport.emit();
  }


  redirect(url: string) {
    this.redirectUrl.emit(url);
  }

  onActionButton(action: string) {
    this.actionOnButton.emit(action);
  }

  innerToggleRow(element: any) {
    this.expandExpandedElement = this.expandExpandedElement === element ? null : element;
    //console.log("===", element);
    this.innerToggledElement = element;
    this.expand = true;
    this.cd.detectChanges();
    // console.log(this.innerTables);
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index]);
  }

  innerToggleRow3(element: any) {
    this.expandExpandedElement3 = this.expandExpandedElement3 === element ? null : element;
    //console.log("===", element);
    this.expand = true;
    this.isExpand3 = true;
    this.cd.detectChanges();
    //console.log(this.innerTables);
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index]);

  }

  toggleRow(element: any) {
    console.log("Inside toggleRow");
    this.expandedElement = this.expandedElement === element ? null : element;
    //console.log("===", element);
    this.expand = true;
    this.cd.detectChanges();
    //console.log(this.innerTables);
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index]);

  }

    onCommissionReportClick(element: any) {
    console.log("Commission Report clicked for element:", element);
    const trackingId = element.trackingId || element.tracking_id;
    console.log("Emitting commission report click with trackingId:", trackingId);
    this.commissionReportClick.emit({ trackingId, element });
  }
  
}
